import React, { useMemo } from "react";
import { Tab, Tabs } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

const TABS = [
  { label: "Zip slots", path: "/dashboard/advertising/slots" },
  { label: "Balance", path: "/dashboard/advertising/balance" },
  { label: "Performance", path: "/dashboard/advertising/performance" },
];

const ZipSlotAdsTabs = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const value = useMemo(() => {
    const match = TABS.find((tab) => pathname === tab.path);
    return match ? match.path : TABS[0].path;
  }, [pathname]);

  return (
    <Tabs
      value={value}
      onChange={(_, next) => navigate(next)}
      sx={{ mb: 3, borderBottom: 1, borderColor: "divider" }}
      variant="scrollable"
      scrollButtons="auto"
    >
      {TABS.map((tab) => (
        <Tab key={tab.path} label={tab.label} value={tab.path} />
      ))}
    </Tabs>
  );
};

export default ZipSlotAdsTabs;
